module.exports = __webpack_public_path__ + "img/welcome_24.61634abd.jpg";